import { useSelector } from 'react-redux';
import _isEqual from 'lodash/isEqual';

const useCustomSelector = (selector) => {
  return useSelector(selector, _isEqual);
};

export default useCustomSelector;